import { render, staticRenderFns } from "./GetMenuTitle.vue?vue&type=template&id=2789be4a"
import script from "./GetMenuTitle.vue?vue&type=script&lang=js"
export * from "./GetMenuTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports